module.exports = __webpack_public_path__ + "static/media/Boar_jerky.845e8b46.png";